import { SilentRequest } from "@azure/msal-browser"
import { getPca } from "../../authProvider"
import { getConfiguration, getConfigurationItem } from "../../config"
import { getBuFromCache, getlangFromCache } from "../../utils"
import { Roles } from "../../utils"
import { LocalStorageKeys } from "../../utils/local-storage-keys"
export * from "./req_blob"
export * from "./req_family-tech"
export * from "./req_products"
export * from "./req_supplier-parameters"
export * from "./req_family-com"
export * from "./req_multi-modif"
export * from "./req_user"
export * from "./req_vat"
export * from "./req_territoi"
export * from "./req_brands"
export * from "./req_customs"
export * from "./req_product-form"
export * from "./req_translations"
export * from "./req_reference-isg-urls"
export * from "./req_maintenance"
export * from "./req_warranty"

export interface IHttpParams {
  key: string
  value: any
}

export const $myFetch = (
  path: string,
  options: any = { headers: new Headers() },
  params: IHttpParams[] = [],
  role: Roles = Roles.SUPPLIER,
  supplierName?: string
) => {
  const request: SilentRequest = getConfiguration().AUTHENTICATION_PARAMETERS
  const pca = getPca()
  return pca
    .acquireTokenSilent(request)
    .then((res) => {
      const myHeaders = options.headers
      myHeaders.set("Authorization", "Bearer " + res.accessToken)

      params = supplierName
        ? params.concat([{ key: "supplierName", value: supplierName }])
        : params.concat(getSupplierName(role))
      const lang = getlangFromCache() || "fr"
      const bu = getBuFromCache() || null
      const route = `/api/${path}?lang=${lang}&marketLeaderBu=${
        bu?.marketLeaderBusinessUnit || null
      }&supplierBu=${bu?.supplierBusinessUnit || null}${
        params.length > 0 ? "&" : ""
      }${params.map((param) => param.key + "=" + param.value).join("&")}`
      return fetch(route, options).then((res) => {
        if (res.status >= 300) {
          throw new Error(res.statusText)
        }
        return res
      })
    })
    .catch((err) => {
      if (err.name === "AbortError") return err
      if (
        err.name === "AuthError" ||
        err.name === "InteractionRequiredAuthError" ||
        err.name === "ClientAuthError" ||
        err.name === "ServerError" ||
        err.name === "ClientConfigurationError"
      ) {
        sessionStorage.clear()
        pca.loginRedirect()
      }
      return err
    }) as Promise<Response>
}

export const $getAllTopRefs = (): Promise<any> => {
  const myHeaders = new Headers()
  return $myFetch("repairCaratech", {
    headers: myHeaders,
    method: "GET",
  }).then((res) => res.json())
}

export const $repairColor = (): Promise<any> => {
  const myHeaders = new Headers()
  return $myFetch("repairCaratech/color", {
    headers: myHeaders,
    method: "GET",
  }).then((res) => res.json())
}

export const $repairCaratech = (): Promise<any> => {
  const myHeaders = new Headers()
  return $myFetch("repairCaratech", {
    headers: myHeaders,
    method: "POST",
  }).then((res) => res.json())
}

const getSupplierName = (role: Roles) => {
  const stored = localStorage.getItem(LocalStorageKeys.SELECTED_SUPPLIER)
  return role === Roles.MARKET_LEADER
    ? [
        {
          key: "supplierName",
          value: stored,
        },
      ]
    : []
}
